import React from 'react';

export default function BeforeYouStart() {
  return (
    <>
      <h2>Before you start</h2>
      <p>
        <b>If you think your life or health is in danger, </b>
        go to the nearest emergency room or call 911. If you’re not sure if your
        condition is an emergency, contact your primary care provider.
        <br />{' '}
        <a href="/find-locations">Find your nearest VA health facility</a>
        <br />{' '}
        <a href="/initiatives/emergency-room-911-or-urgent-care/">
          Learn more about emergency medical care at VA
        </a>
      </p>
    </>
  );
}
